export default "__VITE_ASSET__d9e5b8fe__"